import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { UserDao } from '@app/dao/user/user.dao';
import { UtilsService } from '@app/providers/utils/utils.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PrFormService } from './pr-form.service';

@Injectable({
  providedIn: 'root',
})
export class PrFormConstructor {
  constructor(
    public analyticsService: GoogleAnalyticsService,
    public formBuilder: UntypedFormBuilder,
    public prFormService: PrFormService,
    public utilsService: UtilsService,
    public notificationService: NotificationsService,
    public userDao: UserDao,
  ) {}
}
